var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 38,
    viewBox: "0 0 49 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_881_2187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3763 23.0994H11.4175C10.8599 23.0994 10.4074 22.6441 10.4074 22.0829V21.6092C10.4074 20.0292 11.6803 18.7482 13.2503 18.7482H23.5458C25.1158 18.7482 26.3887 20.0292 26.3887 21.6092V22.0829C26.3865 22.6441 25.9362 23.0994 25.3763 23.0994Z",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6353 23.0994H15.1587V24.9048C15.1587 25.2613 15.4466 25.551 15.8009 25.551H20.9932C21.3474 25.551 21.6353 25.2613 21.6353 24.9048V23.0994Z",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.397 37.885C19.1859 37.885 19.8254 37.2415 19.8254 36.4476C19.8254 35.6538 19.1859 35.0103 18.397 35.0103C17.6082 35.0103 16.9687 35.6538 16.9687 36.4476C16.9687 37.2415 17.6082 37.885 18.397 37.885Z",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2269 37.885C11.0158 37.885 11.6552 37.2415 11.6552 36.4476C11.6552 35.6538 11.0158 35.0103 10.2269 35.0103C9.43805 35.0103 8.79856 35.6538 8.79856 36.4476C8.79856 37.2415 9.43805 37.885 10.2269 37.885Z",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7521 37.885C27.541 37.885 28.1804 37.2415 28.1804 36.4476C28.1804 35.6538 27.541 35.0103 26.7521 35.0103C25.9633 35.0103 25.3238 35.6538 25.3238 36.4476C25.3238 37.2415 25.9633 37.885 26.7521 37.885Z",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.397 25.5511V35.0126",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0268 35.2586L18.397 27.6899L25.9523 35.2586",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66571 11.7176H2.24652H0.114292V37.7654H3.66571V14.8845H32.9501V37.7654H48.8858V14.8845V13.0975V11.7176H3.66571Z",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6782 14.9833H35.4434V35.5323H46.6782V14.9833Z",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3128 20.6823V18.4515",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5158 0.11499H11.2782V23.0994H25.5158V0.11499Z",
    fill: "white",
    stroke: "#666879",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5158 14.0381H11.2782V15.9286H25.5158V14.0381Z",
    fill: "#C0DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5158 18.7482H11.2782V20.6386H25.5158V18.7482Z",
    fill: "#C0DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5158 9.32812H11.2782V11.2186H25.5158V9.32812Z",
    fill: "#C0DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5158 4.61572H11.2782V6.50618H25.5158V4.61572Z",
    fill: "#C0DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5158 0.11499H11.2782V2.00545H25.5158V0.11499Z",
    fill: "#C0DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2782 4.61572H25.5158",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2782 9.32812H25.5158",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2782 14.0381H25.5158",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2782 18.7482H25.5158",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5158 0.11499H11.2782V23.0994H25.5158V0.11499Z",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_881_2187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 38,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesk);
export default __webpack_public_path__ + "static/media/desk.5c54d761.svg";
export { ForwardRef as ReactComponent };